import React from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'gatsby'
import styled from 'styled-components'
import GoogleMapReact from 'google-map-react'
import { IoMdPin } from 'react-icons/io'
import { device } from '../components/Breakpoints'
import { colors } from '../components/Colors'
import { Breadcrumb } from '../components/Breadcrumb'
import VejaTambem from '../components/VejaTambem'
import Layout from '../components/Layout'
import PageHeader from '../components/PageHeader'

const Container = styled.section`
  order: 1;
  width: 100%;
`
const Horarios = styled.section`
  box-sizing: border-box;
  margin: 0em 0 1em;
  width: 100%;
  padding: 2em 0;
  background: ${colors.laranjaGradienteReverso};
  .inner {
    padding-left: 5em;
    @media ${device.mobileL} {
      padding-left: 2em;
    }
  }
  h3 {
    position: relative;
    color: #f4edc6;
    @media ${device.mobileL} {
      margin-bottom: 0;
    }
    svg {
      position: absolute;
      left: -70px;
      top: -3px;
      font-size: 0.6em;
      color: #f4edc6;
      @media ${device.mobileL} {
        position: static;
        font-size: 0.5em;
        vertical-align: bottom;
        margin-right: 1em;
      }
    }
  }
  h4 {
    color: #f4edc6;
    font-size: 0.9em;
    margin-bottom: 0;
  }
  ul {
    margin: 0 0 1em;
    padding: 0;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    li {
      list-style: none;
      padding: 0;
      width: 100%;
      min-height: 150px;
      margin-bottom: 1em;
      display: flex;
      justify-content: space-between;
      align-items: center;
      @media ${device.mobileL} {
        flex-wrap: wrap;
      }
      .col1 {
        padding: 20px 0px;
        width: 30%;
        div {
          padding: 20px 0px;
        }
      }
      .map {
        min-height: 250px !important;
        width: 65%;
        padding-right: 2em;
        box-sizing: border-box;
        margin-top: 50px;
        overflow: hidden;
        > div {
          min-height: 250px !important;
        }
        @media ${device.mobileL} {
          width: 100%;
        }
      }
      div {
        position: relative;
        :last-child {
          :after {
            border: none;
          }
        }
        :after {
          content: '';
          border-bottom: 1px solid #f4edc6;
          width: 35px;
          position: absolute;
          bottom: 0px;
          left: 0;
        }
      }
      @media ${device.mobileL} {
        width: 100%;
      }
      a {
        color: #ffffff;
        text-decoration: none;
      }
      p,
      address {
        color: #ffffff;
      }
    }
  }
  p,
  address {
    font-size: 0.8em;
    margin: 0;
  }
  address {
    margin-top: 10px;
  }
`
const Map = () => (
  <div>
    <IoMdPin size="2em" color="red" />
  </div>
)

export const OndeEstamosTemplate = ({
  title,
  content,
  slug,
  image,
  color,
  addresses,
}) => {
  const crumbs = [
    { id: 1, link: '/', title: 'Home', icon: true },
    { id: 2, link: slug, title },
  ]
  const GoogleMapsKey = 'AIzaSyCLOHkYMoPTOSfoQxhwpV4wXbo1EkYJvqI'
  return (
    <>
      <Container>
        <Breadcrumb crumbs={crumbs} />

        <PageHeader
          title={title}
          content={content}
          image={image}
          color={color}
          txtColor="cinza"
          overflow="visible"
          height="153px"
        />
        <Horarios>
          <div className="inner center">
            <h3>
              <IoMdPin size="2.5em" />
              Endereços
            </h3>
            <ul>
              {addresses.map(address => (
                <li key={address.endereco.placeId}>
                  <div className="col1">
                    <h4>{address.titulo}</h4>
                    <div>
                      <p>
                        <a href="tel:(11) 5080-6000">{address.telefone}</a>
                      </p>
                    </div>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: address.horarioDeFuncionamento,
                      }}
                    />
                    <div
                      dangerouslySetInnerHTML={{ __html: address.descricao }}
                    />
                  </div>
                  <div className="map">
                    <GoogleMapReact
                      bootstrapURLKeys={{
                        key: GoogleMapsKey,
                      }}
                      yesIWantToUseGoogleMapApiInternals
                      defaultCenter={{
                        lat: address.endereco.latitude,
                        lng: address.endereco.longitude,
                      }}
                      defaultZoom={16}
                      resetBoundsOnResize
                    >
                      <Map
                        lat={address.endereco.latitude}
                        lng={address.endereco.longitude}
                      />
                    </GoogleMapReact>
                    <address>{address.endereco.streetAddress}</address>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </Horarios>
      </Container>
    </>
  )
}

OndeEstamosTemplate.propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.string,
}

const OndeEstamos = ({ data }) => {
  const { siteMetadata: site } = data.site
  const { wpPage: page } = data
  const image = page.opEsDaPGina.imagem ? page.opEsDaPGina.imagem.sourceUrl : ''
  const { paginasRelacionadas } = page.opEsDaPGina
  const { itens: addresses } = page.enderecos
  const description = page.excerpt
    ? page.excerpt.replace(/<\/?[^>]+(>|$)/g, '').replace(/\n/g, '')
    : ''

  return (
    <Layout title={`${page.title} – ${site.title}`} description={description}>
      <OndeEstamosTemplate
        title={page.title}
        content={page.content}
        image={image}
        slug={page.slug}
        color={page.opEsDaPGina.corDoCabecalho}
        addresses={addresses}
      />
      <VejaTambem relatedPages={paginasRelacionadas} />
    </Layout>
  )
}

OndeEstamos.propTypes = {
  data: PropTypes.object.isRequired,
}

export default OndeEstamos

export const OndeEstamosQuery = graphql`
  query OndeEstamosById($id: String!) {
    site {
      siteMetadata {
        url
        title
      }
    }
    wpPage(id: { eq: $id }) {
      title
      content
      slug
      excerpt
      enderecos {
        itens {
          descricao
          telefone
          titulo
          horarioDeFuncionamento
          endereco {
            latitude
            longitude
            placeId
            streetAddress
          }
        }
      }
      opEsDaPGina {
        corDoCabecalho
        imagem {
          sourceUrl
        }
        paginasRelacionadas {
          ... on WpPage {
            id
            title
            slug
          }
        }
      }
    }
  }
`
